/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
// import alert from 'react-s-alert';
import * as c from './constant';

export const getPermissionList = (
  payload = { is_paginated: 0, sort_by: 'desc' },
  callback
) => req.list(c.GET_PERMISSION, 'api/v1/administrators/permissions', payload, callback);

export const getPermission = (payload, callback) =>
  req.list(
    c.GET_PERMISSION,
    `api/v1/administrators/permissions/`,
    payload,
    callback
  );

export const createPermission = (payload, callback) =>
  req.create(
    c.CREATE_PERMISSION,
    `api/v1/administrators/permissions/`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updatePermission = (id, payload, callback) =>
  req.update(
    c.UPDATE_PERMISSION,
    `api/v1/administrators/permissions/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removePermission = (id, payload, callback) =>
  req.remove(
    c.REMOVE_PERMISSION,
    `api/v1/administrators/permissions/${id}`,
    payload,
    callback
  );

export const showPermission = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_SETTING,
    `api/v1/administrators/permissions/${id}`,
    payload,
    callback
  );
